module.exports = __webpack_public_path__ + "static/media/alert.10d5c229.svg";